import { normalizeHighlightSearchText } from './highlightSearchText';

// The narrowest element subtree that contains the quote. A chunk can span sibling elements, so elem
// (the chunk's first element) may not contain the quote - widen up to the nearest ancestor that does.
const resolveQuoteSearchRoot = (
  element: HTMLElement | null,
  editorDom: HTMLElement,
  highlightText: string
): HTMLElement | null => {
  if (!element) return editorDom;
  const needle = normalizeHighlightSearchText(highlightText);
  if (!needle) return null;

  for (let node: HTMLElement | null = element; node; node = node.parentElement) {
    // Stop before the editor root so we never match the same text elsewhere in the document.
    if (node === editorDom) break;
    if (normalizeHighlightSearchText(node.textContent ?? '').includes(needle)) return node;
  }
  // No ancestor contains the quote -> caller can decide whether to search a wider root.
  return null;
};

export default resolveQuoteSearchRoot;
